import React from "react";
import hero from "../../assets/images/hero.png";
import { useTranslation } from "react-i18next";
import { Carousel } from "antd";
import hero2 from "../../assets/images/hero2.png";
import hero3 from "../../assets/images/hero3.png";
import heroMobile from "../../assets/images/NewMobile1.png";
import heroMobile1 from  "../../assets/images/NewMobile2.png";
import heroMobile2 from "../../assets/images/NewMobile3.png";
import heroMobile3 from "../../assets/images/NewMobile3.png";
import heroMobile4 from "../../assets/images/NewMobile3.png";
import heroMobile5 from "../../assets/images/NewMobile3.png";

import useIsMobile from "../../biblio/mobileVersion/useIsMobile";
import HeroCard from "../../biblio/Cards/HeroCard";
import line from "../../assets/icons/line-arrow.svg";
import hero5 from "../../assets/images/hero5.png";
import hero6 from "../../assets/images/hero6.png";
import hero7 from "../../assets/images/hero7.png";
import hero0 from "../../assets/images/Hero0.png";
import heroMobile0 from "../../assets/images/HeroMobile0.png";

interface HeroSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  id?: string;
}
const HeroSection = ({ ...props }: HeroSectionProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const heroImages = [
    isMobile ? heroMobile0 : hero0,
    isMobile ? heroMobile : hero,
    isMobile ? heroMobile1 : hero2,
    isMobile ? heroMobile2 : hero3,
    isMobile ? heroMobile3 : hero5,
    isMobile ? heroMobile4 : hero6,
    isMobile ? heroMobile5 : hero7,
  ];
  return (
    <section
      {...props}
      className={`takaful--hero-section-container ${props.className ?? ""}`}
    >
      <img src={line} alt="" className="takaful--lineeee" />
      <Carousel
        speed={1000}
        dots={false}
        arrows={isMobile ? false : true}
        autoplaySpeed={10000}
        autoplay
        effect="fade"
        className="takaful--hero-section-carousel"
      >
        {heroImages.map((imageSrc, index) => (
          <div key={index}>
            <img
              className="takaful--hero-section-image"
              src={imageSrc}
              alt="hero"
            />
            <HeroCard
              herotitle={t("hero.title1")}
              subTitle={t("hero.title2")}
              span={t("hero.span")}
              title={t("hero.title3")}
              subTitle1={t("hero.title4")}
            />
          </div>
        ))}
      </Carousel>
    </section>
  );
};

export default HeroSection;
